(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1768],{

/***/ 82490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ twilio_developer_plan; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(83490);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(47480);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(79547);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* eslint-disable camelcase */








var copy = {
  overline: "Twilio Developer Plan",
  heading: "Unify your customer data with Segment and Twilio",
  description: "Build a centralized data pipeline for your web, app, and Twilio or Sendgrid campaign data with the Twilio Developer Plan from Segment",
  cta: {
    text: "Sign up for free"
  }
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHero, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overline, {
          tag: "h5",
          variant: "h5",
          children: copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pExtraLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
            additionalParams: {
              twilio_developer_offer: "1"
            },
            children: copy.cta.text
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "480",
            height: "560",
            src: (Hero_2x_default()),
            alt: "Twilio Developer Plan",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "eeujsqt2"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHero = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "eeujsqt1"
} : 0)(recipes_Hero/* Wrapper */.im, "{align-items:start;}" + ( true ? "" : 0));

var Overline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "eeujsqt0"
} : 0)( true ? {
  name: "1i9vogi",
  styles: "margin-top:0"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var LogoCarousel = __webpack_require__(6087);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/Carousel/Carousel.tsx




var logos = [data/* carouselLogos.IBM */.j.IBM, data/* carouselLogos.ALLERGAN */.j.ALLERGAN, data/* carouselLogos.INTUIT */.j.INTUIT, data/* carouselLogos.FOX */.j.FOX, data/* carouselLogos.LEVIS */.j.LEVIS];

var Carousel = function Carousel() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel["default"], {
      logos: logos,
      heading: "Companies using Twilio & Segment"
    })
  });
};

var Carousel_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jsiffa0"
} : 0)("margin-top:40px;margin-bottom:20px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{margin-top:60px;margin-bottom:60px;}" + ( true ? "" : 0));

/* harmony default export */ var Carousel_Carousel = (Carousel);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Tabs/index.ts + 3 modules
var Tabs = __webpack_require__(74117);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 93 modules
var Brandbook = __webpack_require__(52065);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CarouselCard/index.ts + 2 modules
var CarouselCard = __webpack_require__(49183);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SectionTabbed/index.ts + 2 modules
var SectionTabbed = __webpack_require__(86926);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/assets/CollectUserEventData@2x.png
var CollectUserEventData_2x = __webpack_require__(43646);
var CollectUserEventData_2x_default = /*#__PURE__*/__webpack_require__.n(CollectUserEventData_2x);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/assets/CollectUserEventData.webp
var CollectUserEventData = __webpack_require__(94672);
var CollectUserEventData_default = /*#__PURE__*/__webpack_require__.n(CollectUserEventData);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/assets/CollectUserEventData@2x.webp
var assets_CollectUserEventData_2x = __webpack_require__(34378);
var assets_CollectUserEventData_2x_default = /*#__PURE__*/__webpack_require__.n(assets_CollectUserEventData_2x);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/CollectUserEventDataImage.tsx








var CollectUserEventDataImage = function CollectUserEventDataImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((CollectUserEventData_default()), ", ").concat((assets_CollectUserEventData_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "618",
      height: "946",
      src: (CollectUserEventData_2x_default()),
      alt: "Illustration: Collect User Event Data",
      loading: "lazy"
    })]
  });
};

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1e91usk0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[1];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var CollectAndProcess_CollectUserEventDataImage = (CollectUserEventDataImage);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/assets/LeveragePreBuiltCloudSources@2x.png
var LeveragePreBuiltCloudSources_2x = __webpack_require__(10847);
var LeveragePreBuiltCloudSources_2x_default = /*#__PURE__*/__webpack_require__.n(LeveragePreBuiltCloudSources_2x);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/assets/LeveragePreBuiltCloudSources.webp
var LeveragePreBuiltCloudSources = __webpack_require__(92880);
var LeveragePreBuiltCloudSources_default = /*#__PURE__*/__webpack_require__.n(LeveragePreBuiltCloudSources);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/assets/LeveragePreBuiltCloudSources@2x.webp
var assets_LeveragePreBuiltCloudSources_2x = __webpack_require__(59189);
var assets_LeveragePreBuiltCloudSources_2x_default = /*#__PURE__*/__webpack_require__.n(assets_LeveragePreBuiltCloudSources_2x);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/LeveragePreBuiltCloudSourcesImage.tsx








var LeveragePreBuiltCloudSourcesImage = function LeveragePreBuiltCloudSourcesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LeveragePreBuiltCloudSourcesImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((LeveragePreBuiltCloudSources_default()), ", ").concat((assets_LeveragePreBuiltCloudSources_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "618",
      height: "899",
      src: (LeveragePreBuiltCloudSources_2x_default()),
      alt: "Illustration: Leverage Pre Built Cloud Sources",
      loading: "lazy"
    })]
  });
};

var LeveragePreBuiltCloudSourcesImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e16w4c9z0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[1];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var CollectAndProcess_LeveragePreBuiltCloudSourcesImage = (LeveragePreBuiltCloudSourcesImage);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/assets/SendTheData@2x.png
var SendTheData_2x = __webpack_require__(40202);
var SendTheData_2x_default = /*#__PURE__*/__webpack_require__.n(SendTheData_2x);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/assets/SendTheData.webp
var SendTheData = __webpack_require__(24018);
var SendTheData_default = /*#__PURE__*/__webpack_require__.n(SendTheData);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/assets/SendTheData@2x.webp
var assets_SendTheData_2x = __webpack_require__(446);
var assets_SendTheData_2x_default = /*#__PURE__*/__webpack_require__.n(assets_SendTheData_2x);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/SendTheDataImage.tsx








var SendTheDataImage = function SendTheDataImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SendTheDataImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((SendTheData_default()), ", ").concat((assets_SendTheData_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "888",
      src: (SendTheData_2x_default()),
      alt: "Illustration: Send The Data",
      loading: "lazy"
    })]
  });
};

var SendTheDataImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "emkxi2u0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[1];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var CollectAndProcess_SendTheDataImage = (SendTheDataImage);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/CollectAndProcess/CollectAndProcess.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CollectAndProcess_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var CollectAndProcess_copy = {
  heading: "Collect and process your customer data at scale",
  description: "Twilio Segment is a Customer Data Platform that enables you to use a single API to collect, standardize, and unify your customer data. Segment handles over 1 million events per second and is trusted by over 200,000 developers.",
  tabs: [{
    key: "collect-user-event-data",
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* DataCollectIcon */.BL, {}),
    title: "Implement tracking on your website or mobile apps to collect clickstream data",
    image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectAndProcess_CollectUserEventDataImage, {})
  }, {
    key: "leverage-pre-built-cloud-sources",
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* DownloadCloudIcon */.ND, {}),
    title: "Leverage pre-built cloud sources for Twilio and Sendgrid to collect campaign data",
    image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectAndProcess_LeveragePreBuiltCloudSourcesImage, {})
  }, {
    key: "send-the-data",
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* ChartIcon */.Cy, {}),
    title: "Send that data to a data warehouse for deeper analysis (and other tools on a paid Segment plan)",
    image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectAndProcess_SendTheDataImage, {})
  }]
};

var CollectAndProcess = function CollectAndProcess() {
  var _useTabs = (0,Tabs/* useTabs */.YE)(CollectAndProcess_copy.tabs[0].key),
      activeTabKey = _useTabs.activeTabKey,
      getTabsProps = _useTabs.getTabsProps,
      getTabsMotionProps = _useTabs.getTabsMotionProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionComponent, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionTabbedBaseStyled, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionTabbed/* Copy */.CK, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              tag: "h2",
              variant: "h2",
              children: CollectAndProcess_copy.heading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              tag: "p",
              children: CollectAndProcess_copy.description
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs/* default */.ZP, _objectSpread(_objectSpread({}, getTabsProps()), {}, {
              mode: "vertical",
              variant: "filled",
              children: CollectAndProcess_copy.tabs.map(function (tab) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCard/* default */.ZP, {
                  value: tab.key,
                  active: activeTabKey === tab.key,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CarouselCardContainer, {
                    alignment: "left",
                    headerPosition: "top",
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCard/* Header */.h4, {
                      children: tab.icon
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCard/* Body */.uT, {
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCard/* Title */.Dx, {
                        children: tab.title
                      })
                    })]
                  })
                }, tab.key);
              })
            }))
          })]
        }), CollectAndProcess_copy.tabs.map(function (tab) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTabbed/* Media */.pU, _objectSpread(_objectSpread({}, getTabsMotionProps(tab.key)), {}, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTabbed/* Picture */.t, {
              children: tab.image
            })
          }), tab.key);
        })]
      })
    })
  });
};

var SectionComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ebzt0o03"
} : 0)("overflow:hidden;", Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var SectionTabbedBaseStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SectionTabbed/* default */.ZP,  true ? {
  target: "ebzt0o02"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{gap:140px;}" + ( true ? "" : 0));

var CarouselCardContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CarouselCard/* Container */.W2,  true ? {
  target: "ebzt0o01"
} : 0)( true ? "" : 0);

var TabsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebzt0o00"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

/* harmony default export */ var CollectAndProcess_CollectAndProcess = (CollectAndProcess);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/Features/assets/Features@2x.png
var Features_2x = __webpack_require__(81043);
var Features_2x_default = /*#__PURE__*/__webpack_require__.n(Features_2x);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/Features/assets/Features.webp
var Features = __webpack_require__(89816);
var Features_default = /*#__PURE__*/__webpack_require__.n(Features);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/Features/assets/Features@2x.webp
var assets_Features_2x = __webpack_require__(10536);
var assets_Features_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Features_2x);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/Features/FeaturesImage.tsx


function FeaturesImage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var FeaturesImage = function FeaturesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeaturesImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Features_default()), ", ").concat((assets_Features_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
      src: (Features_2x_default()),
      alt: "Illustration: What you\u2019ll get from the Twilio Developer Plan from Segment",
      width: "626",
      height: "554",
      loading: "lazy"
    })]
  });
};

var FeaturesImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e5fobl61"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[1];
}, ");" + ( true ? "" : 0));

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e5fobl60"
} : 0)( true ? {
  name: "105cn3m",
  styles: "max-width:526px"
} : 0);

/* harmony default export */ var Features_FeaturesImage = (FeaturesImage);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/Features/Features.tsx


function Features_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var Features_copy = {
  heading: "What you\u2019ll get from the Twilio Developer Plan from Segment",
  cta: {
    text: "Learn more",
    href: "https://segment.com/docs/guides/usage-and-billing/twilio-developer-plan/"
  },
  featuresList: [{
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* NamingConventionsIcon */.eo, {}),
    title: "Unified customer database",
    description: "Build a unified view of your customers by loading campaign data from Twilio or Sendgrid and clickstream data from your websites or apps into a data warehouse."
  }, {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* DataIcon */.d1, {}),
    title: "Query-ready data",
    description: "Data loaded into your warehouse is automatically optimized for cost and performance, and schematized to make querying simple."
  }, {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* UnderstandingIcon */.A4, {}),
    title: "Deep customer insights",
    description: "Leverage your unified customer data set to evaluate campaign performance and deliverability metrics, analyze historical trends, and power data science models. "
  }]
};

var Features_Features = function Features() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
          variant: "h2",
          tag: "h2",
          children: Features_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          children: Features_copy.featuresList.map(function (_ref, index) {
            var icon = _ref.icon,
                title = _ref.title,
                description = _ref.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBoxComponent, {
              alignment: "left",
              headerPosition: "left",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                  elevation: 1,
                  variant: "circle",
                  children: icon
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: description
                })]
              })]
            }, index);
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
          href: (0,getAbsoluteUrl/* default */.Z)(Features_copy.cta.href, pageConfig),
          children: Features_copy.cta.text
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Features_FeaturesImage, {})
    })]
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1xcfcxo4"
} : 0)( true ? {
  name: "1tx7fyb",
  styles: "max-width:1320px"
} : 0);

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e1xcfcxo3"
} : 0)( true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0);

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1xcfcxo2"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;}" + ( true ? "" : 0));

var StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Link */.rU,  true ? {
  target: "e1xcfcxo1"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding-left:70px;}" + ( true ? "" : 0));

var FeatureBoxComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "e1xcfcxo0"
} : 0)(function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("md");
}, "{", FeatureBox/* CSSHeaderPositionTop */.Hq, ";}" + ( true ? "" : 0));

/* harmony default export */ var components_Features_Features = (Features_Features);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/Plan/assets/TwilioDeveloperPlan@2x.png
var TwilioDeveloperPlan_2x = __webpack_require__(19275);
var TwilioDeveloperPlan_2x_default = /*#__PURE__*/__webpack_require__.n(TwilioDeveloperPlan_2x);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/Plan/assets/TwilioDeveloperPlan.webp
var TwilioDeveloperPlan = __webpack_require__(67163);
var TwilioDeveloperPlan_default = /*#__PURE__*/__webpack_require__.n(TwilioDeveloperPlan);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/components/Plan/assets/TwilioDeveloperPlan@2x.webp
var assets_TwilioDeveloperPlan_2x = __webpack_require__(77662);
var assets_TwilioDeveloperPlan_2x_default = /*#__PURE__*/__webpack_require__.n(assets_TwilioDeveloperPlan_2x);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/Plan/PlanImage.tsx


function PlanImage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var PlanImage_FeaturesImage = function FeaturesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlanImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((TwilioDeveloperPlan_default()), ", ").concat((assets_TwilioDeveloperPlan_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanImage_StyledImage, {
      src: (TwilioDeveloperPlan_2x_default()),
      alt: "Illustration: What you\u2019ll get from the Twilio Developer Plan from Segment",
      width: "400",
      height: "410",
      loading: "lazy"
    })]
  });
};

var PlanImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e12736lg1"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[1];
}, ");" + ( true ? "" : 0));

var PlanImage_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e12736lg0"
} : 0)( true ? {
  name: "1y0ex1",
  styles: "max-width:400px"
} : 0);

/* harmony default export */ var PlanImage = (PlanImage_FeaturesImage);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/Plan/Plan.tsx


function Plan_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* eslint-disable camelcase */










var Plan_copy = {
  subtitle: "Free every month",
  heading: "Twilio Developer Plan",
  description: "Activate audiences in ".concat("450", "+ marketing and analytics tools in real time."),
  details: "* All other details are similar to Segment\u2019s Team plan."
};

var Plan = function Plan() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Plan_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      reverse: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Plan_SectionCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: Plan_copy.subtitle
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: Plan_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: Plan_copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonsWrapper, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
            additionalParams: {
              twilio_developer_offer: "1"
            },
            children: "Sign up"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            variant: "outlined",
            color: "primary",
            size: "medium",
            href: "https://segment.com/docs/guides/usage-and-billing/twilio-developer-plan/",
            children: "View documentation"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(List, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TypographyItem, {
              variant: "h5",
              tag: "p",
              children: ["3 Sources", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "h6",
                tag: "span",
                children: "\xA0(+1 from standard free plan)"
              })]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypographyItem, {
              variant: "h5",
              tag: "p",
              children: "1 Warehouse Destination"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TypographyItem, {
              variant: "h5",
              tag: "p",
              children: ["10,000 MTUs", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "h6",
                tag: "span",
                children: "\xA0(+9,000 from standard free plan)"
              })]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypographyItem, {
              variant: "h5",
              tag: "p",
              children: "10 seats"
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "pMedium",
          tokens: {
            color: theme.palette.twilio.gray[80]
          },
          children: Plan_copy.details
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanImage, {})
      })]
    })
  });
};

var Plan_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e6lgyu95"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var Plan_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e6lgyu94"
} : 0)("direction:ltr;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;}" + ( true ? "" : 0));

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e6lgyu93"
} : 0)( true ? {
  name: "wq5ynl",
  styles: "margin-top:40px;padding-left:30px"
} : 0);

var ListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e6lgyu92"
} : 0)( true ? "" : 0);

var TypographyItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e6lgyu91"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var ButtonsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e6lgyu90"
} : 0)( true ? {
  name: "z9nzdq",
  styles: "margin-top:24px;display:flex;gap:16px"
} : 0);

/* harmony default export */ var Plan_Plan = (Plan);
// EXTERNAL MODULE: ../../libs/templates/TestimonialSlider/index.ts + 11 modules
var TestimonialSlider = __webpack_require__(88302);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 250 modules
var CompanyMono = __webpack_require__(68536);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 258 modules
var Company = __webpack_require__(13922);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/Testimonials/data.tsx





var testimonialData = function testimonialData() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return [{
    company: "good-eggs",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* GoodeggsMonoLogo */.nCX, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* GoodeggsLogo */.jO8, {}),
    logoName: "GoodEggs"
  }, {
    company: "clear-score",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ClearScoreMonoLogo */.Ojb, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* ClearScoreLogo */.Kgu, {}),
    logoName: "ClearScore"
  }, {
    company: "halp",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* HalpMonoLogo */.JRr, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* HalpLogo */.xsl, {}),
    logoName: "Halp"
  }];
};


;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/components/Testimonials/Testimonials.tsx


function Testimonials_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Testimonials = function Testimonials() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonials_StyledSection, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialSlider["default"], {
      data: testimonialData,
      title: false,
      innerStyles: false
    })
  });
};

var Testimonials_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e14vpn1z0"
} : 0)( true ? {
  name: "ct1lmz",
  styles: "max-width:1260px;overflow-x:inherit"
} : 0);

/* harmony default export */ var Testimonials_Testimonials = (Testimonials);
// EXTERNAL MODULE: ./src/views/TwilioDeveloperPlan/assets/OgImage.png
var OgImage = __webpack_require__(89461);
var OgImage_default = /*#__PURE__*/__webpack_require__.n(OgImage);
;// CONCATENATED MODULE: ./src/views/TwilioDeveloperPlan/TwilioDeveloperPlan.tsx
















var GettingStarted = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(442), __webpack_require__.e(2576)]).then(__webpack_require__.bind(__webpack_require__, 42576));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(42576)];
    }
  }
});

var TwilioEngageView = function TwilioEngageView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Twilio Developer Plan | Twilio Segment",
      pageDescription: "Unify your customer data with Twilio Segment and Twilio.",
      pageOG: (OgImage_default()),
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel_Carousel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectAndProcess_CollectAndProcess, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Features_Features, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Plan_Plan, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonials_Testimonials, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "ep6g5ze0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var TwilioDeveloperPlan_TwilioDeveloperPlan = (TwilioEngageView);
;// CONCATENATED MODULE: ./src/pages/twilio-developer-plan.tsx



var twilio_developer_plan_TwilioDeveloperPlan = function TwilioDeveloperPlan() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwilioDeveloperPlan_TwilioDeveloperPlan, {});
};

/* harmony default export */ var twilio_developer_plan = (twilio_developer_plan_TwilioDeveloperPlan);

/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 6087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/LogoCarousel.tsx


var _excluded = ["heading", "logos", "appearance", "headingVariant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getDefaultLogos = function getDefaultLogos(logosMap) {
  return [logosMap.DIGITAL_OCEAN, logosMap.IBM, logosMap.DOMINOS, logosMap.ANHEUSER_BUSCH, logosMap.VMWARE, logosMap.LEVIS, logosMap.LOG_ME_IN, logosMap.CLEAR_SCORE, logosMap.VACASA, logosMap.STAPLES, logosMap.INTUIT, logosMap.THE_SKIMM, logosMap.DRIFT, logosMap.ALLERGAN, logosMap.GLOSSIER, logosMap.AB_IN_BEV];
};

var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      externalAppearance = _ref.appearance,
      headingVariant = _ref.headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var finalLogos = externalLogos !== null && externalLogos !== void 0 ? externalLogos : getDefaultLogos(appearance === "twilioLight" ? data/* carouselLogos */.j : data/* carouselLogosMono */.G);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, _objectSpread(_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      variant: headingVariant,
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: finalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/index.ts


/***/ }),

/***/ 72005:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/twilio-developer-plan",
      function () {
        return __webpack_require__(82490);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89461:
/***/ (function(module) {

module.exports = "/_next/static/images/OgImage-f358dfc844109333f87066cb63ccfdd5.png";

/***/ }),

/***/ 43646:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectUserEventData@2x-0a497786c18cbb55e09624828a252c9e.png";

/***/ }),

/***/ 10847:
/***/ (function(module) {

module.exports = "/_next/static/images/LeveragePreBuiltCloudSources@2x-7d99614e52c981ed1f05a70619b891cf.png";

/***/ }),

/***/ 40202:
/***/ (function(module) {

module.exports = "/_next/static/images/SendTheData@2x-f947842856b295e0c37097269857bf20.png";

/***/ }),

/***/ 81043:
/***/ (function(module) {

module.exports = "/_next/static/images/Features@2x-f7733700ccce8b1db23d8ad5fc1bc7e7.png";

/***/ }),

/***/ 83490:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-7d007fca5cdd24db564701bbf999feaa.png";

/***/ }),

/***/ 19275:
/***/ (function(module) {

module.exports = "/_next/static/images/TwilioDeveloperPlan@2x-9a1f22b0ff2fa9b754511868f12b8598.png";

/***/ }),

/***/ 94672:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectUserEventData-1470deaeda720a0dbdef63b0bf4794f1.webp";

/***/ }),

/***/ 34378:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectUserEventData@2x-6a0cd93d54da4569d4520b55fe70a404.webp";

/***/ }),

/***/ 92880:
/***/ (function(module) {

module.exports = "/_next/static/images/LeveragePreBuiltCloudSources-ca8c58e6d17029ba34dac03736600d58.webp";

/***/ }),

/***/ 59189:
/***/ (function(module) {

module.exports = "/_next/static/images/LeveragePreBuiltCloudSources@2x-4618b1ab49ab1831b0a66bd7765682c3.webp";

/***/ }),

/***/ 24018:
/***/ (function(module) {

module.exports = "/_next/static/images/SendTheData-88238c0710a2826433ac484151cd49c5.webp";

/***/ }),

/***/ 446:
/***/ (function(module) {

module.exports = "/_next/static/images/SendTheData@2x-80d5cd6706dec95834bcdeebadae4731.webp";

/***/ }),

/***/ 89816:
/***/ (function(module) {

module.exports = "/_next/static/images/Features-51d2e79e2723370ba068ced669ca2173.webp";

/***/ }),

/***/ 10536:
/***/ (function(module) {

module.exports = "/_next/static/images/Features@2x-e84e22165498b6513aa88e064d9163ae.webp";

/***/ }),

/***/ 47480:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-e72464ae198523054f2f10888dab8628.webp";

/***/ }),

/***/ 79547:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-797532c239dd47ed5d88cf49066eb4f3.webp";

/***/ }),

/***/ 67163:
/***/ (function(module) {

module.exports = "/_next/static/images/TwilioDeveloperPlan-db2252f49d9397e089120fc2f427b4be.webp";

/***/ }),

/***/ 77662:
/***/ (function(module) {

module.exports = "/_next/static/images/TwilioDeveloperPlan@2x-1d7a8c28565244fa1f11e6c8899b591e.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,7209,4495,1382,4136,8392,2073,7096,2429,7303,8187,3922,8536,3379,2065,5062,814,8302,9600,5190,8940,9774,2888,179], function() { return __webpack_exec__(72005); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);